'use strict';

angular.module('PinMeTo.featureFlag').directive('pmtFeatureFlag', [
	'$animate',
	'$compile',
	'pmtFeatureFlagService',
	function ($animate, $compile, pmtFeatureFlagService) {
		return {
			multiElement: true,
			transclude: 'element',
			priority: 777,
			terminal: true,
			restrict: 'A',
			$$tlb: true,
			scope: {
				feature: '@pmtFeatureFlag'
			},
			link: function ($scope, $element, $attr, ctrl, $transclude) {
				let enabled = function () {
					$transclude(function (clone) {
						clone[clone.length++] = $compile.$$createComment(
							'end pmtFeatureFlag',
							$attr.pmtFeatureFlag
						);
						$animate.enter(clone, $element.parent(), $element);
					});
				};

				let disabled = function () {};

				pmtFeatureFlagService
					.hasFeature($scope.feature)
					.then(hasFeature => (hasFeature ? enabled() : disabled()));
			}
		};
	}
]);
